// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3BX4z","savePackageButton":"ClientWallet_savePackageButton__2mn8E"};